export { Icons25 } from "./Icons25";
